import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import { Checkbox, Dropdown, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import objectAssign from 'object-assign';
import { updateDuringCallsForm } from '../../../../actions/waitingArea.js';

const RecordCallsOptions = [
  { value: 'true', text: APP.LANGUAGE.Yes },
  { value: 'false', text: APP.LANGUAGE.No },
];

export default function CenterPanelUpdate(props) {
  const dispatch = useDispatch();
  const [displayMessageCharsLeft, setDisplayMessageCharsLeft] = useState(
    480 - props.duringCallsForm.message.substr(0, 480).length
  );
  const [maxChars, setMaxChars] = useState(480);

  const duringCallsFormUpdated = (updatedObject) => {
    let updatedDuringCallsForm = objectAssign({}, props.duringCallsForm, updatedObject);
    return updatedDuringCallsForm;
  };

  const displayMessageChange = (value) => {
    value = value.substr(0, 480);
    let checkLinebreaks = value.match(/\r?\n/g);

    if (!!checkLinebreaks) {
      // Counting newline characters' number
      let linebreaks = checkLinebreaks.length;
      if (linebreaks < 10) {
        setDisplayMessageCharsLeft(maxChars - value.length);

        let updatedProperties = {
          message: value,
        };
        dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
      }
    } else {
      setDisplayMessageCharsLeft(maxChars - value.length);

      let updatedProperties = {
        message: value,
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    }
  };

  const changeCallQuality = (event, data) => {
    let updatedProperties = {
      callQuality: data.value,
    };
    dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
  };

  const testMinutesOrSeconds = (value) => {
    let regex = new RegExp('^[0-9]{0,2}$');
    if ((regex.test(value) && parseInt(value) >= 0 && parseInt(value) <= 60) || value == '') {
      return true;
    }
    return false;
  };

  const changeDisplayMessageMinutes = (value) => {
    if (testMinutesOrSeconds(value)) {
      let updatedProperties = {
        displayMessageMinutes: value == '' ? '' : parseInt(value),
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    }
  };

  const changeDisplayMessageSeconds = (value) => {
    if (testMinutesOrSeconds(value)) {
      let updatedProperties = {
        displayMessageSeconds: value == '' ? '' : parseInt(value),
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    }
  };

  const changeAllowRecording = (event, data) => {
    if (data.value == 'true') {
      let updatedProperties = {
        isRecordingEnabled: true,
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    } else {
      let updatedProperties = {
        isRecordingEnabled: false,
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    }
  };

  const setMinutesToZero = (value) => {
    if (value == '') {
      let updatedProperties = {
        displayMessageMinutes: 0,
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    }
  };

  const setSecondsToZero = (value) => {
    if (value == '') {
      let updatedProperties = {
        displayMessageSeconds: 0,
      };
      dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
    }
  };

  const changeShowBackDrop = () => {
    let updatedProperties = {
      showWaitingAreaBulletin: !props.duringCallsForm.showWaitingAreaBulletin,
    };
    dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
  };

  const changeShowCallerQueuePosition = () => {
    if (!props.duringCallsForm.enableCalculateQueuePosition) {
      return;
    }
    let updatedProperties = {
      showCallerQueuePosition: !props.duringCallsForm.showCallerQueuePosition,
    };
    dispatch(updateDuringCallsForm(duringCallsFormUpdated(updatedProperties)));
  };

  const getToggelText = (value) => {
    return value ? 'ON' : 'OFF';
  };

  const renderQueuePositionCheckbox = (isOnDesktop) => {
    return (
      <>
        <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
          <div className="toggle-box mrrs" onClick={changeShowCallerQueuePosition}>
            <div className="toggle-text text-size-ms">
              {getToggelText(props.duringCallsForm.showCallerQueuePosition)}
            </div>
            <Checkbox
              toggle
              disabled={!props.duringCallsForm.enableCalculateQueuePosition}
              checked={props.duringCallsForm.showCallerQueuePosition}
            />
          </div>
          <div className="ui no-bold title-sms pdtsss pdbxxs pdrnull txt-left">
            {APP.LANGUAGE.DuringCallsModal.ShowCallerQueuePosition}
          </div>
        </div>
        <div className="display-flex" data-show={!props.duringCallsForm.enableCalculateQueuePosition}>
          <div className="toggle-box-space mrrs" />
          <div className="title-sms text-size-mms borderless pdtsss pdbxxs pdrnull">
            {APP.LANGUAGE.DuringCallsModal.CallerQueuePositionSubtitle}
          </div>
        </div>
      </>
    );
  };

  const renderBackDropCheckbox = () => {
    return props.isWaitingAreaBulletinEnabled ? (
      <>
        <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
          <div className="toggle-box mrrs" onClick={changeShowBackDrop}>
            <div className="toggle-text text-size-ms">
              {getToggelText(props.duringCallsForm.showWaitingAreaBulletin)}
            </div>
            <Checkbox toggle checked={props.duringCallsForm.showWaitingAreaBulletin} />
          </div>
          <div className="ui no-bold title-sms pdtsss pdbxxs pdrnull txt-left">
            {APP.LANGUAGE.DuringCallsModal.ShowBackdrop}
          </div>
        </div>
      </>
    ) : (
      ''
    );
  };

  const hasEanbleRecordingAccess =
    props.waitingArea.permissions.indexOf('ENABLE_RECORDING') > -1 &&
    props.duringCallsForm.isOrganisationRecordingEnabled;

  return (
    <div className="ui form during-calls-form">
      <div className="">
        <div className="max-width mrbm">
          <div className="placeholder-label no-bold div-like color-placeholder">
            {APP.LANGUAGE.DuringCallsModal.CallQualityTitle}
          </div>
          <Dropdown
            placeholder={props.callQualityOptions[0].text}
            defaultValue={props.duringCallsForm.callQuality}
            onChange={changeCallQuality}
            fluid
            selection
            options={props.callQualityOptions}
          />
          <div>
            <div className="sixteen wide column mrtl mrbm">
              <div className="placeholder-label no-bold div-like color-placeholder">
                {APP.LANGUAGE.DuringCallsModal.MessageToDisplay}
              </div>
              <Txt
                textArea
                tabIndex="2"
                value={props.duringCallsForm.message.substr(0, 480)}
                fieldClasses="ui input textarea mrbnull"
                placeholder={APP.LANGUAGE.DuringCallsModal.MessageToDisplay}
                notRenderPlaceholderAsTitle={false}
                onChange={displayMessageChange}
                focusme="true"
              />
              <div className="wa-charsRight small-font-size mrbs">
                <span>{APP.LANGUAGE.NotifyCaller.CharactersRemaining + displayMessageCharsLeft}</span>
              </div>
            </div>
          </div>
          <div className="clearfix">
            <span
              style={{ lineHeight: '2em' }}
              className={props.duringCallsForm.message == (null || '') ? 'disable-text mrtm mrrxs' : 'mrtm mrrxs'}
            >
              {APP.LANGUAGE.DuringCallsModal.DisplayMsgAfterPart}
            </span>
            <div className="inline-flex">
              <Txt
                number
                tabIndex="2"
                placeholder=""
                value={props.duringCallsForm.displayMessageMinutes}
                onChange={changeDisplayMessageMinutes}
                onBlur={setMinutesToZero}
                maxLength={2}
                disabled={props.duringCallsForm.message == (null || '')}
                fieldClasses="ui input inline-input mrrxs mrtxs non-transparent-input input-number"
              />
              <span
                className={
                  props.duringCallsForm.message == (null || '') ? 'disable-text add-margin mrrxs' : 'add-margin mrrxs'
                }
              >
                minutes
              </span>
            </div>
            <div className="inline-flex">
              <Txt
                number
                tabIndex="2"
                placeholder=""
                value={props.duringCallsForm.displayMessageSeconds}
                onChange={changeDisplayMessageSeconds}
                maxLength={2}
                onBlur={setSecondsToZero}
                disabled={props.duringCallsForm.message == (null || '')}
                fieldClasses="ui input inline-input mrtxs mrrxs non-transparent-input input-number"
              />
              <span
                className={
                  props.duringCallsForm.message == (null || '') ? 'disable-text add-margin mrrxs' : 'add-margin mrrxs'
                }
              >
                seconds.
              </span>
            </div>
          </div>

          {props.isRecordingAvailableOnPortal === true ? (
            <div className="mrtm clearfix">
              <span
                className={
                  hasEanbleRecordingAccess
                    ? 'sms-title inline-flex mrtm mrrs pdbxs'
                    : ' disable-text sms-title inline-flex mrtm mrrs pdbxs'
                }
              >
                {APP.LANGUAGE.DuringCallsModal.IfRecorded}
              </span>
              <Dropdown
                className="inline-input inline-flex non-transparent-input"
                defaultValue={props.duringCallsForm.isRecordingEnabled.toString()}
                onChange={changeAllowRecording}
                disabled={!hasEanbleRecordingAccess}
                selection
                fluid
                options={RecordCallsOptions}
              />
            </div>
          ) : (
            ''
          )}
          {/* Show Caller Queue Position */}
          <div className="clearfix mrtl">
            <Container fluid as={Media} lessThan="computer">
              {renderQueuePositionCheckbox(false)}
            </Container>
            <Container fluid as={Media} greaterThanOrEqual="computer">
              {renderQueuePositionCheckbox(true)}
            </Container>
          </div>
          <div className="mrtm">{renderBackDropCheckbox()}</div>
        </div>
      </div>
    </div>
  );
}
